import { LuBriefcase, LuChartBar, LuHandHeart, LuPersonStanding, LuSchool, LuTrophy } from 'react-icons/lu'

export const experienceTypes = [
  { key: 'job', title: 'Job', icon: LuBriefcase },
  { key: 'education', title: 'Education', icon: LuSchool },
  { key: 'milestone', title: 'Milestone', icon: LuChartBar },
  { key: 'volunteer', title: 'Volunteer', icon: LuHandHeart },
  { key: 'award', title: 'Award', icon: LuTrophy },
  { key: 'personal', title: 'Personal', icon: LuPersonStanding },
].map(x => ({ ...x, id: x.key }))
